import { Fragment } from 'react'
import AppStyleDecider from '../../../../../../../../../../../baseComponents/AppsStyleDecider'
import { OrderStepButtonsBaseComponentProps } from '../../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent/types'
import { SellOrderStatusBarProps } from '../../../../../SellOrders/SingleSellOrder/SellOrderStatusBar'
import SellInvoiceStatusBar, { SellInvoiceStatusBarNew } from '../../../SellInvoiceStatusBar'
import SellInvoiceCreateStepButtons, { SellInvoiceCreateStepButtonsNew } from '../SellInvoiceCreateStepButtons'

type SellInvoiceCreateStepHeaderProps = & SellOrderStatusBarProps & OrderStepButtonsBaseComponentProps

const SellInvoiceCreateStepHeaderDecider: React.FC<SellInvoiceCreateStepHeaderProps> = ({ ...rest }) => {
    return (
        <AppStyleDecider DefaultComponent={SellInvoiceCreateStepHeaderDefault} NewComponent={SellInvoiceCreateStepHeaderNew} {...rest} />
    )
}

const SellInvoiceCreateStepHeaderDefault: React.FC<SellInvoiceCreateStepHeaderProps> = ({ ...rest }) => {
    return (
        <div className='flex gap-10 justify-between flex-wrap items-center flex-auto'>
            <SellInvoiceStatusBar {...rest} />
            <SellInvoiceCreateStepButtons {...rest} />
        </div>
    )
}

const SellInvoiceCreateStepHeaderNew: React.FC<SellInvoiceCreateStepHeaderProps> = ({ ...rest }) => {
    return (
        <Fragment>
            <SellInvoiceStatusBarNew {...rest} />
            <SellInvoiceCreateStepButtonsNew {...rest} />
        </Fragment>
    )
}

export default SellInvoiceCreateStepHeaderDecider